import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const OrdersPage = lazy(() => import('@cobliteam/crm/src/pages/OrdersPage'));
const OrderDetailsPage = lazy(() => import('@cobliteam/crm/src/pages/OrderDetailsPage/OrderDetailsPage'));
/*
 * Experimento `orders-ai-page`. A rota existe sempre; quem guarda a porta é a própria página, que
 * redireciona para /orders quando a flag está desligada. Registrar a rota condicionalmente aqui
 * quebraria o code splitting e faria o módulo de rotas depender do provider do LaunchDarkly.
 */
const OrdersAIPage = lazy(() => import('@cobliteam/crm/src/pages/OrdersAIPage'));

const routes = [
  {
    path: Location.ORDERS,
    team: 'squad-account-experience',
    component: OrdersPage,
    exact: true,
  },
  {
    path: Location.ORDERS_AI,
    team: 'squad-account-experience',
    component: OrdersAIPage,
    exact: true,
  },
  {
    path: Location.ORDER_DETAILS,
    team: 'squad-account-experience',
    component: OrderDetailsPage,
    exact: true,
  },
];

export default routes;
